import { CheckCircle, AlertTriangle, XCircle, Bell, X } from "lucide-react";

const PayrollNotifications = ({ notifications = [], onDismiss }) => {
  if (notifications.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm">
      {notifications.map((notif) => (
        <div
          key={notif.id}
          className="p-4 rounded-lg border-l-4 transition-all duration-300 animate-in slide-in-from-right"
          style={{
            backgroundColor: "var(--lm-s2)",
            borderColor: "var(--lm-border)",
            borderLeftColor: notif.type === "success" ? "#27a644"
              : notif.type === "warning" ? "#f59e0b"
              : notif.type === "error" ? "#e5484d"
              : "#5e6ad2",
          }}
        >
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              {notif.type === "success" && <CheckCircle className="h-5 w-5 text-green-600" />}
              {notif.type === "warning" && <AlertTriangle className="h-5 w-5 text-amber-600" />}
              {notif.type === "error" && <XCircle className="h-5 w-5 text-red-600" />}
              {notif.type === "info" && <Bell className="h-5 w-5 text-blue-600" />}
            </div>
            <div className="flex-1">
              <p className="font-semibold text-sm">{notif.title}</p>
              <p className="text-xs opacity-90 mt-1">{notif.message}</p>
              <p className="text-xs opacity-70 mt-2">{notif.timestamp}</p>
            </div>
            <button
              onClick={() => onDismiss(notif.id)}
              className="flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PayrollNotifications;
